"use client";

import React from "react";
import type { FloorPlanName } from "@/app/floor-plans/types";
import Container from "@/components/ui/layout/container";
import Section from "@/components/ui/layout/section";
import GalleryCard from "../GalleryCard";

const SECTION_ID = "project-gallery";

interface ProjectsGallerySectionProperties {
  floorPlanName: FloorPlanName;
}

function GallerySection({ floorPlanName }: ProjectsGallerySectionProperties) {
  return (
    <Section id={SECTION_ID}>
      <Container id={SECTION_ID} maxWidth="max-w-5xl">
        <GalleryCard
          floorPlanName={floorPlanName}
          title={floorPlanName}
          sub="FLOOR PLANS"
          description="3D Renderings & Floor Plans for Your Enjoyment"
          showCTA={false}
        />
      </Container>
    </Section>
  );
}

export default GallerySection;
